<template>
  <div class="orderForm">
    <div class="form__card">
      <div class="form__block">
        <h4 class="form__title">{{ $t('order.info') }}</h4>
        <div v-if="isExternalHotelSource" class="pt-24 pb-8">
          <i class="owl-status-triangle-warning text-orange" />
          <span class="font-semibold">{{ $t('enNameInputWarning') }}</span>
        </div>
        <div class="form__form w-full">
          <div class="form__form-full flex flex-wrap">
            <div class="form__form-half">
              <label for="customerFirstName">
                <template v-if="isExternalHotelSource">{{ $t('enFirstName') }}</template>
                <template v-else>{{ $t('firstName') }}</template>
              </label>
              <input
                type="text"
                v-model="customerFirstName"
                class="form__content input w-full"
                name="customerFirstName"
                :placeholder="isExternalHotelSource ? $t('enFirstName') : $t('firstName')"
              >
              <div class="errorMsg">{{ validation.firstError('customerFirstName') }}</div>
            </div>
            <div class="form__form-half mt-32 sm:mt-0">
              <label for="customerLastName">
                <template v-if="isExternalHotelSource">{{ $t('enLastName') }}</template>
                <template v-else>{{ $t('lastName') }}</template>
              </label>
              <input
                type="text"
                v-model="customerLastName"
                class="form__content input w-full"
                name="customerLastName"
                :placeholder="isExternalHotelSource ? $t('enLastName') : $t('lastName')"
              >
              <div class="errorMsg">{{ validation.firstError('customerLastName') }}</div>
            </div>
          </div>
          <div class="form__form-full flex flex-wrap">
            <div class="w-full sm:w-1/3 sm:pr-8 pl-0 flex-no-shrink">
              <label for="">{{ $t('phoneCode') }}</label>
              <el-select
                v-model="customerPhoneCode"
                class="form__content phone-code-select w-full"
                filterable
                :no-match-text="$t('noResults')"
                :no-data-text="$t('number.0')"
                :placeholder="$t('phoneCode')">
                <el-option
                  v-for="(country, index) in this['user/phoneCodes']"
                  :key="`customer-phonecode-${ index }-${ country.phoneCode }`"
                  :label="`+${ country.phoneCode } (${ country.name })`"
                  :value="country.phoneCode">
                </el-option>
              </el-select>
              <div class="errorMsg">{{ validation.firstError('customerPhoneCode') }}</div>
            </div>
            <div class="sm:pl-8 w-full sm:w-2/3 mt-32 sm:mt-0">
              <label for="">{{ $t('phone') }}</label>
              <input type="tel" v-model="customerPhoneNumber" class="form__content input w-full" name="customerPhoneNumber" :placeholder="$t('phone')">
              <div class="errorMsg">{{ validation.firstError('customerPhoneNumber') }}</div>
            </div>
          </div>
          <div class="form__form-full">
            <label for="">{{ $t('userTitle') }}</label>
            <div class="form__gender flex mt-8 flex-col sm:flex-row">
              <div class="form__gender-radio owl-radio-wrap">
                <label for="customerGenderMale">
                  <input type="radio" id="customerGenderMale" name="customerGender" v-model="customerGender" value="male">
                  <div class="owl-radio"></div>
                  <span>{{ $t('male') }}</span>
                </label>
              </div>
              <div class="form__gender-radio owl-radio-wrap mt-16 sm:mt-0">
                <label for="customerGenderFemale">
                  <input type="radio" id="customerGenderFemale" name="customerGender" v-model="customerGender" value="female">
                  <div class="owl-radio"></div>
                  <span>{{ $t('female') }}</span>
                </label>
              </div>
              <div class="form__gender-radio owl-radio-wrap mt-16 sm:mt-0">
                <label for="customerGenderUnknown">
                  <input type="radio" id="customerGenderUnknown" name="customerGender" v-model="customerGender" value="unknown">
                  <div class="owl-radio"></div>
                  <span>{{ $t('notProvide') }}</span>
                </label>
              </div>
            </div>
          </div>
          <!-- <div class="form__form-full">
            <label for="customerPhone">電話</label>
            <input type="text" v-model="customerPhone" class="form__content input w-full" name="customerPhone" placeholder="Phone">
            <div class="errorMsg">{{ validation.firstError('customerPhone') }}</div>
          </div> -->
          <div class="form__form-full">
            <label for="customerEmail">{{ $t('email') }}</label>
            <input type="email" v-model="customerEmail" class="form__content input w-full border-none" :class="{'hasEmail': customerEmail}" name="customerEmail" :placeholder="$t('email')" :disabled="this['user/isLogin'] ? customerEmail : false">
            <div class="errorMsg">{{ validation.firstError('customerEmail') }}</div>
          </div>
          <div v-if="!this['user/isLogin']" class="form__form-full">
            <label for="customerEmail">{{ $t('emailConfirm') }}</label>
            <input type="email" v-model="customerEmailConfirm" class="form__content input w-full" name="customerEmailConfirm" :placeholder="$t('email')" onpaste="return false;" >
            <div class="errorMsg">{{ validation.firstError('customerEmailConfirm') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="form__card">
      <div class="form__block">
        <div class="form__block-head flex-col sm:flex-row items-start sm:items-center">
          <h4 class="form__title">{{ $t('travelerAsOrder') }}</h4>
          <div class="form__switcher mt-24 sm:mt-0">
            <div class="form__switcher-radio owl-radio-wrap">
              <label for="sameAsOrder">
                <input type="radio" id="sameAsOrder" name="asOrder" v-model="asOrder" :value="true">
                <div class="owl-radio"></div>
                <span>{{ $t('yes') }}</span>
              </label>
            </div>
            <div class="form__switcher-radio owl-radio-wrap">
              <label for="noSameAsOrder">
                <input type="radio" id="noSameAsOrder" name="asOrder" v-model="asOrder" :value="false">
                <div class="owl-radio"></div>
                <span>{{ $t('no') }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="form__form form-switched w-full xl:w-2/3" :class="asOrder ? '' : 'show'">
          <div v-if="isExternalHotelSource" class="pb-32">
            <i class="owl-status-triangle-warning text-orange" />
            <span class="font-semibold">{{ $t('enNameInputWarning') }}</span>
          </div>
          <div class="form__form-full flex flex-wrap">
            <div class="form__form-half">
              <label for="">
                <template v-if="isExternalHotelSource">{{ $t('enFirstName') }}</template>
                <template v-else>{{ $t('firstName') }}</template>
              </label>
              <input
                type="text"
                v-model="travelerFirstName"
                class="form__content input w-full"
                name="travelerFirstName"
                :placeholder="isExternalHotelSource ? $t('enFirstName') : $t('firstName')"
              >
              <div class="errorMsg">{{ validation.firstError('travelerFirstName') }}</div>
            </div>
            <div class="form__form-half mt-32 sm:mt-0">
              <label for="">
                <template v-if="isExternalHotelSource">{{ $t('enLastName') }}</template>
                <template v-else>{{ $t('lastName') }}</template>
              </label>
              <input
                type="text"
                v-model="travelerLastName"
                class="form__content input w-full"
                name="travelerLastName"
                :placeholder="isExternalHotelSource ? $t('enLastName') : $t('lastName')"
              >
              <div class="errorMsg">{{ validation.firstError('travelerLastName') }}</div>
            </div>
          </div>
          <div class="form__form-full flex flex-wrap">
            <div class="w-full sm:w-1/3 sm:pr-8 pl-0 flex-no-shrink">
              <label for="">{{ $t('phoneCode') }}</label>
              <el-select
                v-model="travelerPhoneCode"
                class="form__content phone-code-select w-full"
                filterable
                :no-match-text="$t('noResults')"
                :no-data-text="$t('number.0')"
                :placeholder="$t('phoneCode')">
                <el-option
                  v-for="(country, index) in this['user/phoneCodes']"
                  :key="`traveler-phonecode-${ index }-${ country.phoneCode }`"
                  :label="`+${ country.phoneCode } (${ country.name })`"
                  :value="country.phoneCode">
                </el-option>
              </el-select>
              <div class="errorMsg">{{ validation.firstError('travelerPhoneCode') }}</div>
            </div>
            <div class="sm:pl-8 w-full sm:w-2/3 mt-32 sm:mt-0">
              <label for="">{{ $t('phone') }}</label>
              <input type="tel" v-model="travelerPhoneNumber" class="form__content input w-full" name="travelerPhoneNumber" :placeholder="$t('phone')">
              <div class="errorMsg">{{ validation.firstError('travelerPhoneNumber') }}</div>
            </div>
          </div>
          <div class="form__form-full">
            <label for="">{{ $t('userTitle') }}</label>
            <div class="form__gender flex mt-8 flex-col sm:flex-row">
              <div class="form__gender-radio owl-radio-wrap">
                <label for="travelerGenderMale">
                  <input type="radio" id="travelerGenderMale" name="travelerGender" v-model="travelerGender" value="male">
                  <div class="owl-radio"></div>
                  <span>{{ $t('male') }}</span>
                </label>
              </div>
              <div class="form__gender-radio owl-radio-wrap mt-16 sm:mt-0">
                <label for="travelerGenderFemale">
                  <input type="radio" id="travelerGenderFemale" name="travelerGender" v-model="travelerGender" value="female">
                  <div class="owl-radio"></div>
                  <span>{{ $t('female') }}</span>
                </label>
              </div>
              <div class="form__gender-radio owl-radio-wrap mt-16 sm:mt-0">
                <label for="travelerGenderUnknown">
                  <input type="radio" id="travelerGenderUnknown" name="travelerGender" v-model="travelerGender" value="unknown">
                  <div class="owl-radio"></div>
                  <span>{{ $t('notProvide') }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="form__form-full">
            <label for="">{{ $t('email') }}</label>
            <input type="email" v-model="travelerEmail" class="form__content input w-full" name="travelerEmail" :placeholder="$t('email')">
            <div class="errorMsg">{{ validation.firstError('travelerEmail') }}</div>
            <div class="owl-checkbox-wrap">
              <label for="sendToTraveler">
                <input type="checkbox" id="sendToTraveler" v-model="sendToTraveler">
                <div class="owl-checkbox"></div>
                <span>{{ $t('sendToTraveler') }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="this['order/order'].allowances">
      <div v-for="allowance in this['order/order'].allowances" class="form__card p-16 form__card--blue" :key="allowance.key">
        <div class="form__switcher-checkbox owl-checkbox-wrap">
          <label :for="allowance.key">
            <input type="checkbox" :id="allowance.key" :checked="isAllowance(allowance.key)" @change="toggleAllowance(allowance.key)">
            <div class="owl-checkbox"></div>
            <span>{{ $t('allowanceCheck', { allowanceName: allowance.name }) }}</span>
          </label>
          <div class="flex items-center mt-16 -ml-4">
            <i class="owl-status-triangle-warning text-blue-lighter text-2xl mt-4"></i>
            <span class="text-sm text-blue font-bold">{{ $t('allowanceCheckWarning') }}</span>
          </div>
        </div>
      </div>
    </template>
    <div v-if="this['order/isQuarantineOrder']" class="border-blue-light border-3 mb-24 rounded-sm">
      <div class="form__block">
        <div class="flex items-center mb-24">
          <img height="22px" width="22px" src="@/assets/quarantine-hotels/icon-hotel.svg" class="mr-8" alt="quarantine-hotel-notes" />
          <h4 class="form__title">{{ $t('quarantine.orderNotesTitle') }}</h4>
        </div>
        <div class="leading-loose mb-24">
          <strong>{{ $t('quarantine.orderNotesContent[0]') }}</strong><br>
          <strong class="text-blue">{{ $t('quarantine.orderNotesContent[1]') }}</strong>{{ $t('quarantine.orderNotesContent[2]') }}<br>
          <strong>{{ $t('quarantine.orderNotesContent[3]') }}</strong><br>
          <strong class="text-blue">{{ $t('quarantine.orderNotesContent[4]') }}</strong>
        </div>
        <textarea class="form__content input w-full resize-none" v-model="note" name="note" id="" cols="30" rows="4" :placeholder="$t('pleaseEnterNote')"></textarea>
        <div class="errorMsg">{{ validation.firstError('note') }}</div>
      </div>
    </div>
    <div v-else class="form__card">
      <div class="form__block">
        <div class="form__block-head items-center">
          <h4 class="form__title">{{ $t('specialRequest') }}（{{ $t('notRequired') }}）</h4>
          <div class="form__switcher">
            <label class="owl-switch__wrap">
              <input type="checkbox" v-model="specialRequest">
              <div class="owl-switch__item">
                <div class="owl-switch__bg">
                  <div class="owl-switch__button"></div>
                </div>
              </div>
            </label>
          </div>
        </div>
        <div class="form__form form-switched" :class="specialRequest ? 'show' : ''">
          <div class="form__form-full">
            <div class="form__switcher-title mb-8">{{ $t('commonNeeds') }}</div>
            <div class="form__switcher flex-col sm:flex-row">
              <div class="form__switcher-checkbox owl-checkbox-wrap">
                <label for="lowFloor">
                  <input type="checkbox" id="lowFloor" v-model="lowFloor">
                  <div class="owl-checkbox"></div>
                  <span>{{ $t('meta.lowFloor') }}</span>
                </label>
              </div>
              <div class="form__switcher-checkbox owl-checkbox-wrap ml-0 sm:ml-32 mt-16 sm:mt-0">
                <label for="noSideRoom">
                  <input type="checkbox" id="noSideRoom" v-model="noSideRoom">
                  <div class="owl-checkbox"></div>
                  <span>{{ $t('meta.noSideRoom') }}</span>
                </label>
              </div>
              <div class="form__switcher-checkbox owl-checkbox-wrap ml-0 sm:ml-32 mt-16 sm:mt-0">
                <label for="innerWindow">
                  <input type="checkbox" id="innerWindow" v-model="innerWindow">
                  <div class="owl-checkbox"></div>
                  <span>{{ $t('meta.innerWindow') }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="form__form-full">
            <div class="mb-8">{{ $t('note') }}</div>
            <textarea class="form__content input w-full resize-none" v-model="note" name="" id="" cols="30" rows="4" :placeholder="$t('pleaseEnterNote')"></textarea>
          </div>
          <div class="form__block-notation" v-if="isExternalHotelSource">
            <i class="owl-status-triangle-warning text-orange text-2xl pr-4" />
            <span class="text-sm leading-normal">{{ $t('noteCountryWarningMsg', { country: this['order/order'].hotel.countryText }) }}</span>
          </div>
          <div class="form__block-notation" style="margin-top: 8px">
            <i class="owl-status-triangle-warning text-orange text-2xl pr-4" />
            <span class="text-sm leading-normal">{{ $t('noteWarningMsg') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="this['order/order'].hotel && this['order/order'].hotel.receipt" class="form__card">
      <div class="form__block">
        <h4 class="form__title mb-8">{{ $t('hotelDetail.title.receipt') }}</h4>
        <div class="text-grey-darker list-reset leading-lg pb-16 text-sm">
          {{ this['order/order'].hotel.receipt.context }}
        </div>
        <div class="border-t border-grey-lightest pt-16">
          <div class="form__block-head items-center">
            <h4 class="form__title">{{ $t('needReceipt') }} ({{ $t('notRequired') }})</h4>
            <div class="form__switcher">
              <label class="owl-switch__wrap">
                <input type="checkbox" v-model="needReceipt">
                <div class="owl-switch__item">
                  <div class="owl-switch__bg">
                    <div class="owl-switch__button"></div>
                  </div>
                </div>
              </label>
            </div>
          </div>
          <div class="form__form form-switched" :class="needReceipt ? 'show' : ''">
            <div class="form__form w-full xl:w-2/3">
              <div class="form__form-full flex flex-wrap">
                <div class="form__form-half">
                  <label for="companyName">{{ $t('companyName') }}</label>
                  <input type="text" v-model="companyName" class="form__content input w-full" name="companyName" :placeholder="$t('companyName')">
                  <div class="errorMsg">{{ validation.firstError('companyName') }}</div>
                </div>
                <div class="form__form-half mt-32 sm:mt-0">
                  <label for="companyNumber">{{ $t('companyNumber') }}</label>
                  <input type="text" v-model="companyNumber" class="form__content input w-full" name="companyNumber" :placeholder="$t('companyNumber')">
                  <div class="errorMsg">{{ validation.firstError('companyNumber') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form__card" v-if="this['order/order'].hotel && this['order/order'].hotel.terms">
      <div class="form__block">
        <h4 class="form__title mb-8">{{ $t('hotelDetail.title.bookingTerms') }}</h4>
        <p
          class="text-sm leading-md whitespace-pre-wrap expandable-content"
          v-html="this['order/order'].hotel.terms"
          @click="onContentExpand"></p>
      </div>
    </div>
    <!-- <div class="border border-grey-lighter rounded mt-24 mb-24" v-if="this['order/order'].hotel && this['order/order'].hotel.check && (this['order/order'].hotel.check.checkInStartTimeAt || this['order/order'].hotel.check.checkInEndTimeAt)" style="border-radius: 20px;">
      <div class="flex justify-between flex-col md:flex-row">
        <div v-if="this['order/order'].hotel.check.checkInStartTimeAt" class="flex-auto md:border-r md:border-grey-lightest p-16 pb-24">
          <div class="mb-24 font-bold">{{ $t('checkIn.time') }}</div>
          <div class="text-2xl">
            <span>{{ this['order/order'].hotel.check.checkInStartTimeAt }}</span>
            <span> ~ </span>
            <span>{{ this['order/order'].hotel.check.checkInEndTimeAt }}</span>
          </div>
          <div v-if="this['order/order'].hotel.check.isAllowEarlyCheckIn" class="text-grey-dark text-sm mt-16">
            <span>{{ $t('checkIn.earlyFee') }}</span>
            <span>{{ currencySign }} {{ allowEarlyCheckInPricePerHour | currencyConvert({inputCurrency: this['order/order'].hotel.currency}) }}</span>
            <span>/{{ $t('unit.perHour') }}</span>
          </div>
        </div>
        <div v-if="this['order/order'].hotel.check.checkOutTimeAt" class="flex-auto p-16 pb-24 border-t border-grey-lightest md:border-none">
          <div class="mb-24 font-bold">{{ $t('checkOut.time') }}</div>
          <div class="text-2xl">{{ this['order/order'].hotel.check.checkOutTimeAt }}</div>
          <div v-if="this['order/order'].hotel.check.isAllowLateCheckOut" class="text-grey-dark text-sm mt-16">
            <span>{{ $t('checkOut.latelyFee') }}</span>
            <span>{{ currencySign }} {{ allowLateCheckOutPricePerHour | currencyConvert({inputCurrency: this['order/order'].hotel.currency}) }}</span>
            <span>/{{ $t('unit.perHour') }}</span>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import _ from 'lodash'
import SimpleVueValidator from 'simple-vue-validator'
import fullPageModal from '@/components/modals/fullPageModal'
import contractContent from '@/components/contractContent'
import { createHelpers } from 'vuex-map-fields'
import { mapGetters, mapMutations } from 'vuex'
import animateScrollTo from 'animated-scroll-to'

const { mapFields } = createHelpers({
  getterType: 'order/getField',
  mutationType: 'order/updateField'
})

const Validator = SimpleVueValidator.Validator
// const Validator = SimpleVueValidator.Validator.create({
//   templates: {
//     required: '必填欄位'
//   }
// })

export default {
  name: 'OrderForm',
  metaInfo () {
    return {
      title: '填寫個人資料'
    }
  },
  data () {
    return {}
  },
  validators: {
    'customerFirstName': function (val) {
      const rule = Validator.value(val).required()

      if (this.isExternalHotelSource && !/^[a-zA-Z\s]*$/.test(val)) {
        // 如為外部房源，旅客姓名需輸入英文
        return rule.custom(() => {
          return this.$t('validatorErrors.regex')
        })
      }
      return rule
    },
    'customerLastName': function (val) {
      const rule = Validator.value(val).required()

      if (this.isExternalHotelSource && !/^[a-zA-Z\s]*$/.test(val)) {
        return rule.custom(() => {
          return this.$t('validatorErrors.regex')
        })
      }
      return rule
    },
    'customerPhoneCode': function (val) {
      return Validator.value(val).required()
    },
    'customerPhoneNumber': function (val) {
      return Validator.value(val).required().minLength(7)
    },
    'customerEmail': function (val) {
      return Validator.value(val).required().email()
    },
    'customerEmailConfirm, customerEmail': function (confirmEmail, email) {
      return this['user/isLogin']
        ? null
        : Validator.value(confirmEmail).required().match(email)
    },
    'travelerFirstName': function (val) {
      if (!this.asOrder) {
        const rule = Validator.value(val).required()

        if (this.isExternalHotelSource && !/^[a-zA-Z\s]*$/.test(val)) {
          return rule.custom(() => {
            return this.$t('validatorErrors.regex')
          })
        }
        return rule
      }
    },
    'travelerLastName': function (val) {
      if (!this.asOrder) {
        const rule = Validator.value(val).required()

        if (this.isExternalHotelSource && !/^[a-zA-Z\s]*$/.test(val)) {
          return rule.custom(() => {
            return this.$t('validatorErrors.regex')
          })
        }
        return rule
      }
    },
    'travelerPhoneCode': function (val) {
      if (!this.asOrder) {
        return Validator.value(val).required()
      }
    },
    'travelerPhoneNumber': function (val) {
      if (!this.asOrder) {
        return Validator.value(val).required()
      }
    },
    'travelerEmail': function (val) {
      if (!this.asOrder) {
        return Validator.value(val).required().email()
      }
    },
    'companyName': function (val) {
      const rule = Validator.value(val).minLength(2)
      if (this.needReceipt) {
        if (!this.companyNumber) {
          if (val) { this.$validate('companyNumber') }
        }
        return rule.required()
      }
    },
    'companyNumber': function (val) {
      const rule = Validator.value(val)
        .digit()
        .length(8)
        .custom(() => {
          if (val.length === 8) {
            const idMultiplyRule = [1, 2, 1, 2, 1, 2, 4, 1]
            let isSpecial = false
            const total = String(val).split('').reduce((accumulator, currentValue, index, array) => {
              let sum = Number(currentValue) * idMultiplyRule[index]
              if (index === 6 && Number(currentValue) === 7) {
                isSpecial = true
              }
              if (sum > 9) {
                sum = Number(String(sum).split('')[0]) + Number(String(sum).split('')[1])
              }
              return Number(accumulator) + sum
            })
            if (isSpecial ? (total % 5 !== 0 && (total + 1) % 5 !== 0) : total % 5 !== 0) {
              return this.$t('validatorErrors.companyNumberIsrIncorrect')
            }
          }
        })
      if (this.needReceipt) {
        if (!this.companyName) {
          if (val) { this.$validate('companyName') }
        }
        return rule.required()
      }
    },
    'note': function (val) {
      if (this['order/isQuarantineOrder']) {
        return Validator.value(val).required()
      }
    }
  },
  computed: {
    ...mapGetters([
      'hotels/externalHotelSource',
      'user/profile',
      'user/currencySign',
      'user/phoneCodes',
      'search/totalNights',
      'order/order',
      'order/isQuarantineOrder',
      'user/isLogin'
    ]),
    ...mapFields({
      asOrder: 'form.asOrder',
      needSmoke: 'form.needSmoke',
      specialRequest: 'form.specialRequest',
      needReceipt: 'form.needReceipt',
      companyName: 'form.receiptInfo.companyName',
      companyNumber: 'form.receiptInfo.companyNumber',
      infantBed: 'form.infantBed',
      checkInEarly: 'form.checkInEarly',
      checkOutLately: 'form.checkOutLately',
      lowFloor: 'form.lowFloor',
      noSideRoom: 'form.noSideRoom',
      innerWindow: 'form.innerWindow',
      bedRequest: 'form.bedRequest',
      note: 'form.note',
      customerFirstName: 'form.customer.firstName',
      customerLastName: 'form.customer.lastName',
      customerPhoneCode: 'form.customer.phoneCode',
      customerPhoneNumber: 'form.customer.phoneNumber',
      customerGender: 'form.customer.gender',
      customerEmail: 'form.customer.email',
      customerEmailConfirm: 'form.customer.emailConfirm',
      travelerFirstName: 'form.traveler.firstName',
      travelerLastName: 'form.traveler.lastName',
      travelerPhoneCode: 'form.traveler.phoneCode',
      travelerPhoneNumber: 'form.traveler.phoneNumber',
      travelerGender: 'form.traveler.gender',
      travelerEmail: 'form.traveler.email',
      sendToTraveler: 'form.sendToTraveler',
      allowances: 'form.allowances'
    }),
    currencySign: function () {
      return this['user/currencySign']
    },
    allowEarlyCheckInPricePerHour: function () {
      if (Number(this['order/order'].hotel.check.allowEarlyCheckInPricePerHour) > 0) {
        return this['order/order'].hotel.check.allowEarlyCheckInPricePerHour
      } else {
        // return this.$t('free')
        return 0
      }
    },
    allowLateCheckOutPricePerHour: function () {
      if (Number(this['order/order'].hotel.check.allowLateCheckOutPricePerHour) > 0) {
        return this['order/order'].hotel.check.allowLateCheckOutPricePerHour
      } else {
        // return this.$t('free')
        return 0
      }
    },
    hasOrder: function () {
      return !_.isEmpty(this['order/order'])
    },
    isExternalHotelSource: function () {
      return this['hotels/externalHotelSource'].includes(this['order/order'].source)
    }
  },
  methods: {
    ...mapMutations([
      'order/ADD_ALLOWANCE',
      'order/REMOVE_ALLOWANCE'
    ]),
    toggleAllowance: function (allowanceKey) {
      console.debug('allowanceKey', allowanceKey)
      if (this.isAllowance(allowanceKey)) {
        this['order/REMOVE_ALLOWANCE'](allowanceKey)
      } else {
        this['order/ADD_ALLOWANCE'](allowanceKey)
      }
    },
    isAllowance: function (allowanceKey) {
      return this.allowances.includes(allowanceKey)
    },
    syncTraveler: function () {
      if (this.asOrder) {
        this.travelerFirstName = this.customerFirstName
        this.travelerLastName = this.customerLastName
        this.travelerPhoneCode = this.customerPhoneCode
        this.travelerPhoneNumber = this.customerPhoneNumber
        this.travelerEmail = this.customerEmail
        this.sendToTraveler = false
      } else {
        this.travelerFirstName = ''
        this.travelerLastName = ''
        this.travelerPhoneCode = ''
        this.travelerPhoneNumber = ''
        this.travelerEmail = ''
      }
    },
    openContract: function () {
      this.$modal.show(fullPageModal, {
        // 輸入內容
        context: contractContent
      },
      {
        adaptive: true,
        name: 'contractDetail',
        // clickToClose: false,
        height: '90%',
        width: '90%',
        maxWidth: 1440,
        scrollable: true
      })
    },
    onFormValidate: function () {
      return new Promise((resolve, reject) => {
        this.$validate().then(success => {
          if (success) {
            resolve()
          } else {
            const errorForms = document.getElementsByClassName('errorMsg')
            let errorElement = {}
            for (const el of errorForms) {
              if (el.innerText !== '') {
                errorElement = el
                break
              }
            }

            if (!_.isEmpty(errorElement)) {
              animateScrollTo(errorElement, {
                offset: -200,
                speed: 800
              })
            }
            let errorString = {}
            for (const error of this.validation.errors) {
              errorString[error.field] = {
                message: error.message
              }
            }
            reject(new Error('form error: ' + errorString.join(',')))
          }
        })
      })
    },
    onContentExpand: function ($event) {
      const target = $event.target
      if (target.className.includes('expandable-content')) {
        target.classList.toggle('expanded')
      }
    },
    sendGtm: function () {
      // GTM
      let list = []
      const hotel = this['order/order'].hotel
      if (hotel) {
        _.each(this['order/order'].rooms, room => {
          _.each(room.plans, plan => {
            const count = plan.count
            const id = `hotel/${hotel.hotelUUID}/room/${room.id}/plan/${plan.id}`
            const name = `[${hotel.hotelName}] ${room.name} - ${plan.id}`
            list.push({
              id: id,
              sku: id,
              name: name,
              category: hotel.hotelName,
              list: hotel.hotelName,
              brand: room.name,
              variant: plan.id,
              price: plan.avgPrice,
              quantity: count * Number(this['search/totalNights'])
            })
            // Matomo
            // add the first product to the order
            // window._paq.push(['addEcommerceItem',
            //   id, // (required) SKU: Product unique identifier
            //   name, // (optional) Product name
            //   hotel.hotelName, // (optional) Product category. You can also specify an array of up to 5 categories eg. ["Books", "New releases", "Biography"]
            //   plan.avgPrice, // (recommended) Product price
            //   count * Number(this['search/totalNights']) // (optional, default to 1) Product quantity
            // ])
          })
        })
        // GTM GA4
        window.dataLayer.push({
          event: 'add_shipping_info',
          ecommerce: {
            coupon: '',
            currency: 'TWD',
            value: this['order/order'].total
          }
        })

        let ecDataLayer = {
          'event': 'checkout',
          'ecommerce': {
            'checkout': {
              'actionField': {
                'step': 2,
                'affiliation': this['order/order'].hotel.hotelName
              },
              'products': list
            }
          }
        }
        window.dataLayer.push(ecDataLayer)
      }
    }
  },
  mounted () {
    this.validation.reset()
    // this.sendGtm()
    const user = this['user/profile']
    // if (_.isEmpty(this.customerFirstName) &&
    //   _.isEmpty(this.customerLastName) &&
    //   _.isEmpty(this.customerPhoneCode) &&
    //   _.isEmpty(this.customerPhoneNumber) &&
    //   _.isEmpty(this.customerEmail) &&
    //   _.isEmpty(this.customerGender)
    // ) {
    if (this['user/isLogin']) {
      this.customerFirstName = user.firstName
      this.customerLastName = user.lastName
      this.customerPhoneCode = !_.isEmpty(user.phoneCode) ? +user.phoneCode.replace('+', '') : ''
      this.customerPhoneNumber = user.phoneNumber
      this.customerEmail = user.email
      this.customerGender = user.gender
    }
    // }
  },
  watch: {
    customerFirstName: function () {
      this.syncTraveler()
    },
    customerLastName: function () {
      this.syncTraveler()
    },
    customerPhoneCode: function () {
      this.syncTraveler()
    },
    customerPhoneNumber: function () {
      this.syncTraveler()
    },
    customerEmail: function () {
      this.syncTraveler()
    },
    asOrder: {
      handler: function (val, oldVal) {
        this.syncTraveler()
      },
      immediate: true
    },
    specialRequest: {
      handler: function (val, oldVal) {
        if (val) {
          window.dataLayer.push({
            event: 'order_request_on'
          })
        } else {
          window.dataLayer.push({
            event: 'order_request_off'
          })
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.form__card
  @apply border border-grey-lighter rounded-sm
  @apply mb-24
  border-radius: 20px
  &--blue
    @apply border-blue-light bg-blue-lightest
  &--contract
    @extend .form__card
    @apply border-orange
    @apply bg-orange-lightest
.form__block
  @apply p-16
  @screen sm
    @apply p-24
  & + &
    @apply border-t-1 border-grey-lightest
.form__block-head
  @apply flex justify-between
.form__block-notation
  @apply mt-16
  @apply flex items-center
.form__form
  @apply mt-24
  &.form-switched
    @apply overflow-hidden
    @apply opacity-0
    @apply mt-0
    height: 0
    transition: opacity 0.3s ease
  &.show
    @apply opacity-100
    @apply h-full
    @apply mt-24
  input
    border-radius: 20px

.form__form-half
  @apply w-full
  @screen sm
    @apply pr-8 pl-0 w-1/2
    & + &
      @apply pr-0 pl-8
.form__form-full
  @apply w-full
  & + &
    @apply mt-32

.form__title
  @apply font-bold
.form__section
  @apply text-sm text-grey-dark
  @apply mt-24
.form__content
  @apply text-sm leading-normal
  @apply mt-8
.form__switcher
  @apply flex
.form__switcher-title
  @apply text-base text-grey-darkest
  & + .form__switcher
    @apply mt-8
.form__switcher-radio
  & + &
    @apply ml-32
// .form__switcher-checkbox
//   & + &
//     @apply ml-32
.errorMsg
  @apply text-xs text-red ml-4 mt-8

.form__gender
  &-radio
    @apply mr-32

.phone-code-select::v-deep
  .el-input__inner
    @apply border-none bg-grey-lightest text-grey-darker
    border-radius: 20px
    &::placeholder
      @apply text-grey-dark
    &:focus
      @apply bg-white border-grey-darkest border-1 border-grey-light
      border-style: solid

.expandable-content
  @apply overflow-hidden relative
  z-index: 1
  max-height: 100px
  @screen md
    max-height: 100%
  &::before
    @apply absolute w-full block pin-b pin-l
    height: 100px
    z-index: 2
    content: ''
    background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 35%)
    @screen md
      @apply hidden
  &.expanded
    max-height: 100%
    &::before
      @apply hidden
.hasEmail
  @apply opacity-75 #{!important}
</style>
